import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import layoutOf from 'utils/layoutStyle'
import { Container, Input, EyeToggle } from './styles'

/*
  Campo de senha com a caixa do @cutilei/ui (36 px) e o olho, dentro dela, que mostra ou esconde o
  texto. Do `containerStyle` e do `inputStyle` valem só as chaves de layout.
*/
export default function PasswordInput({
  placeholder,
  value,
  onChange: handleChange,
  onBlur: handleBlur,
  containerStyle = {},
  inputStyle = {}
}) {
  const [hidePass, setHidePass] = useState(true)

  const toggleHidePass = () => setHidePass(!hidePass)

  return (
    <Container style={layoutOf(containerStyle)}>
      <Input
        type={hidePass ? 'password' : 'text'}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        style={layoutOf(inputStyle)}
        autoComplete='off'
      />
      <EyeToggle aria-label={hidePass ? 'Mostrar senha' : 'Esconder senha'} onClick={toggleHidePass}>
        {hidePass ? <Eye size={16} aria-hidden/> : <EyeOff size={16} aria-hidden/>}
      </EyeToggle>
    </Container>
  )
}
